import { render, staticRenderFns } from "./TaskAddEditModal.vue?vue&type=template&id=66beac2b"
import script from "./TaskAddEditModal.vue?vue&type=script&lang=js"
export * from "./TaskAddEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports